// Clientseitige Portierung von calculate_solar() aus backend/server.py.
// Reine Arithmetik -> kein Backend noetig, laeuft direkt im Browser.

// Schweizer Ertragsfaktoren (kWh pro kWp pro Jahr nach Kanton)
export const CANTON_YIELDS = {
  ZH: 1050, BE: 1020, LU: 1080, UR: 1100, SZ: 1080,
  OW: 1120, NW: 1100, GL: 1050, ZG: 1060, FR: 1080,
  SO: 1060, BS: 1040, BL: 1050, SH: 1040, AR: 1040,
  AI: 1050, SG: 1060, GR: 1180, AG: 1060, TG: 1040,
  TI: 1250, VD: 1150, VS: 1280, NE: 1080, GE: 1180, JU: 1050,
};

const ELECTRICITY_PRICE_CHF = 0.30; // CHF / kWh Schweizer Durchschnitt
const FEED_IN_TARIFF_CHF = 0.10;    // CHF / kWh
const CO2_PER_KWH_KG = 0.128;       // Schweizer Strommix
const COST_PER_KWP_CHF = 1900;      // schluesselfertige PV klein/mittel
const BATTERY_COST_CHF = 8000;
const WALLBOX_COST_CHF = 2200;

// Auf n Nachkommastellen runden (entspricht Python round() fuer Anzeigezwecke)
const round = (x, digits = 0) => {
  const f = 10 ** digits;
  return Math.round(x * f) / f;
};

/**
 * @param {{roof_area:number, annual_consumption:number, canton:string,
 *          has_battery:boolean, has_wallbox:boolean}} inp
 */
export function calculateSolar(inp) {
  // grob: ~6 m² pro kWp auf einem typischen Schweizer Wohndach
  const systemSizeKwp = round(inp.roof_area / 6.0, 2);
  const yieldFactor = CANTON_YIELDS[(inp.canton || "ZH").toUpperCase()] ?? 1050;
  const annualYieldKwh = round(systemSizeKwp * yieldFactor);

  let scRatioBase = 0.30;
  if (inp.has_battery) scRatioBase += 0.35;
  if (inp.has_wallbox) scRatioBase += 0.10;
  const scRatio = Math.min(scRatioBase, 0.85);

  const selfConsumption = Math.min(inp.annual_consumption, annualYieldKwh * scRatio);
  const fedIn = Math.max(annualYieldKwh - selfConsumption, 0);

  const annualSavings =
    selfConsumption * ELECTRICITY_PRICE_CHF + fedIn * FEED_IN_TARIFF_CHF;

  let investment = systemSizeKwp * COST_PER_KWP_CHF;
  if (inp.has_battery) investment += BATTERY_COST_CHF;
  if (inp.has_wallbox) investment += WALLBOX_COST_CHF;

  const payback = annualSavings > 0 ? round(investment / annualSavings, 1) : 99.0;
  const twentyYearProfit = annualSavings * 20 - investment;

  return {
    system_size_kwp: systemSizeKwp,
    annual_yield_kwh: annualYieldKwh,
    self_consumption_kwh: round(selfConsumption),
    annual_savings_chf: round(annualSavings),
    co2_reduction_kg: round(annualYieldKwh * CO2_PER_KWH_KG),
    investment_chf: round(investment),
    payback_years: payback,
    twenty_year_profit_chf: round(twentyYearProfit),
  };
}
